export function cropCommonSuffixes(list: string[]): string[] {
  const suffixes = ['INN', 'OON'];

  // Check if all elements end with the same suffix
  const hasCommonSuffix = (suffix: string): boolean => list.every((item) => item.endsWith(` ${suffix}`));

  // Determine which suffix (if any) is common to all elements
  const commonSuffix = suffixes.find(hasCommonSuffix);

  // If there is a common suffix, remove it from each element
  if (commonSuffix) {
    const suffixLength = commonSuffix.length + 1; // +1 for the space before the suffix
    return list.map((item) => item.slice(0, -suffixLength));
  }

  // If no common suffix, replace suffixes with full descriptions
  return list.map((item) => {
    if (item.endsWith('INN')) {
      return item.replace('INN', 'In-Network');
    }
    if (item.endsWith('OON')) {
      return item.replace('OON', 'Out-of-Network');
    }
    return item;
  });
}
